import React, { useState } from 'react';
import MarketingLayout from './Layouts/MarketingLayout';
import { router } from '@inertiajs/react';

export default function Discovery({ portals }) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    router.get('/discovery', { q: searchQuery }, {
      preserveState: true,
      replace: true
    });
  };

  return (
    <MarketingLayout title="Find your School Portal">
      {/* Hero Header */}
      <section className="spx-hero" style={{ paddingBottom: '32px' }}>
        <div className="spx-container animate-fade-in">
          <span className="spx-badge spx-badge-blue" style={{ marginBottom: '16px' }}>Portal Locator</span>
          <h1 className="spx-title-large">Find your school portal</h1>
          <p className="spx-body-lead" style={{ maxWidth: '640px', margin: '0 auto 32px auto' }}>
            Enter your school name or subdomain abbreviation to access your portal login plane.
          </p>

          {/* Search Form */}
          <form onSubmit={handleSearchSubmit} style={{ maxWidth: '500px', margin: '0 auto', display: 'flex', gap: '12px' }}>
            <input 
              type="text" 
              className="spx-input" 
              placeholder="e.g. Greenwood, Bridgeville" 
              style={{ flex: 1, margin: 0 }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              required
            />
            <button type="submit" className="spx-btn spx-btn-primary">
              <i className="fas fa-search"></i> Search
            </button>
          </form>
        </div>
      </section>

      {/* Results Section */}
      <section className="spx-section" style={{ backgroundColor: 'var(--bg-secondary)', borderTop: '1px solid var(--border-primary)' }}>
        <div className="spx-container" style={{ maxWidth: '700px' }}>
          {portals && portals.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <h2 className="spx-title-small" style={{ fontSize: '18px', marginBottom: '8px' }}>Matching Portals</h2>
              {portals.map((portal) => (
                <div 
                  key={portal.id} 
                  className="spx-glass-card" 
                  style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '24px' 
                  }}
                >
                  <div>
                    <h3 className="spx-title-small" style={{ fontSize: '18px', margin: 0 }}>{portal.label}</h3>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '13px', margin: '4px 0 0 0' }}>
                      {portal.public_host || `${portal.subdomain}.schoolplex.ng`}
                    </p>
                  </div>
                  <a 
                    href={portal.public_url || `https://${portal.subdomain}.schoolplex.ng`} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="spx-btn spx-btn-primary"
                    style={{ padding: '8px 16px', fontSize: '14px' }}
                  >
                    Go to Portal <i className="fas fa-external-link-alt" style={{ fontSize: '12px', marginLeft: '4px' }}></i>
                  </a>
                </div>
              ))}
            </div>
          ) : (
            searchQuery && (
              <div className="spx-glass-card text-center" style={{ padding: '48px 32px' }}>
                <div style={{ fontSize: '48px', color: 'var(--text-tertiary)', marginBottom: '16px' }}>
                  <i className="fas fa-search-minus"></i>
                </div>
                <h3 className="spx-title-small" style={{ fontSize: '20px', marginBottom: '8px' }}>No portals found</h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '14px', margin: 0 }}>
                  We couldn't find any registered portals matching "{searchQuery}". Please check the spelling or ask your administrator for your exact link.
                </p>
              </div>
            )
          )}
        </div>
      </section>
    </MarketingLayout>
  );
}
